import React, { useState } from "react";

import { useTheme } from "@material-ui/core/styles";

import { useStyles } from "./MobileRow.styles";

import EmailIcon from "assets/images/email.svg";

import { IconButton } from "@material-ui/core";

import { MoreHorizOutlined as MoreIcon } from "@material-ui/icons";

import classnames from "classnames";
import { getStatusChip } from "../getStatusChip";
import {
  CAMPAIGN_DESCRIPTIONS,
  CAMPAIGN_TYPES,
  EMAIL_TYPES,
} from "ui/pages/communications/CustomEmail/data";
import { Tooltip } from "@my-scoot/component-library-legacy";
import { campaignStepsData } from "../../utils";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";
import MobileCard from "ui/pages/SalesAndMarketing/components/MobileCard";
import { DRIP_SOURCE, STATS_FIELDS } from "../../EmailListItem.constants";
import {
  getPercentage,
  formatRevenue,
} from "features/Common/utils/common.utils";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import RefreshIcon from "@material-ui/icons/Refresh";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import SeeMoreStatsModal from "ui/pages/limitedOffer/seeMoreStatsModal";
import { useRefreshStats } from "utils/hooks/useRefreshStats";
import { statsColumns } from "ui/pages/limitedOffer/seeMoreStatsModalConfig";
import CircularProgress from "@material-ui/core/CircularProgress";

const MobileRow = ({
  alternate,
  email,
  recepients,
  type,
  subject,
  time,
  onViewEditClick,
  onMoreClick,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  const { campaign_step, campaign_type, added_by_name } = email;
  const [showStatsModal, setShowStatsModal] = useState(false);
  const { handleRefreshStats, loading: refreshLoading } = useRefreshStats();

  const getTimePrefix = () => {
    if (type === EMAIL_TYPES.SCHEDULED)
      return <span className={classes.scheduledPrefix}>Scheduled For</span>;
    if (type === EMAIL_TYPES.DRAFT) return "Edited";
    return campaign_type === CAMPAIGN_TYPES.NEW
      ? "Campaign start time:"
      : "Sent";
  };

  const openRate = getPercentage(email.opened_count, email.sent_to_count); // open rate - total number of emails opened/ total number of emails sent
  const clickRate = getPercentage(email.total_clicks, email.sent_to_count); // click rate - people that clicked any link in the email/ total number of emails sent

  return (
    <>
      <MobileCard
        alternate={alternate}
        header={
          <div className="tw-h-[20px] tw-flex tw-items-center tw-justify-between">
            <div className="tw-flex tw-items-center tw-gap-3">
              <ExlyImage src={EmailIcon} alt="email" />

              <span
                className="tw-text-[#493AB1] tw-font-medium tw-underline tw-max-w-[48vw] tw-truncate"
                onClick={onViewEditClick}
              >
                To: {recepients}
              </span>
            </div>

            <div className="tw-flex tw-items-center tw-gap-3">
              {getStatusChip({ type, classes })}

              <IconButton onClick={onMoreClick}>
                <MoreIcon />
              </IconButton>
            </div>
          </div>
        }
        content={[
          {
            title: "Subject:",
            value: subject,
          },
          ...(time
            ? [
                {
                  title: getTimePrefix(),
                  value: time,
                },
              ]
            : []),
          {
            title: "Bookings:",
            value: email?.total_bookings_received ?? 0,
            info: "Total number of transactions that came from email recipients who booked an offering through an email",
          },
          {
            title: "Revenue:",
            value: formatRevenue(email?.total_revenue),
            info: "Total revenue from the bookings that came through email",
          },
        ]}
        stats={
          type === EMAIL_TYPES.PAST
            ? [
                {
                  title: STATS_FIELDS.sentTo,
                  data: email?.sent_to_count ?? 0,
                  icon: "send.png",
                  color: theme?.palette?.primary?.main,
                },
                {
                  title: STATS_FIELDS.openedBy,
                  data: email?.opened_count ?? 0,
                  color: "#00B77A",
                  icon: "drafts.png",
                },
                {
                  title: STATS_FIELDS.openedRate,
                  data: openRate,
                  subData: email?.opened_count ?? 0,
                  color: "#086F86",
                  icon: "percent.png",
                },
                {
                  title: STATS_FIELDS.clickRate,
                  data: clickRate,
                  subData: email?.total_clicks ?? 0,
                  color: "#0052C9",
                  icon: "arrow_selector_tool.png",
                  tooltipText:
                    "People that clicked any link in the email / People to whom the email was sent to",
                },
              ]
            : []
        }
        statColumns={2}
        footer={
          <div className="tw-flex tw-flex-col tw-w-full">
            {campaign_type === CAMPAIGN_TYPES.NEW && (
              <div className="tw-border-solid tw-border-[#E7E6E4] tw-border-b-0 tw-border-r-0 tw-border-l-0 tw-w-full tw-p-3 tw-flex tw-gap-2 tw-items-center">
                <Tooltip
                  arrow
                  color="primary"
                  placement="top"
                  title={added_by_name ? `Added by ${added_by_name}` : ""}
                >
                  <span
                    className={classnames(
                      classes.campaignStep,
                      classes[campaignStepsData[campaign_step].className]
                    )}
                  >
                    {campaignStepsData[campaign_step].label}
                  </span>
                </Tooltip>
                <Tooltip
                  arrow
                  color="primary"
                  placement="top"
                  title={CAMPAIGN_DESCRIPTIONS[campaign_step]}
                >
                  <InfoIcon />
                </Tooltip>
              </div>
            )}

            <div
              className="tw-bg-[#EEECF9] tw-text-[#493AB1] tw-p-3 tw-flex tw-items-center tw-justify-center tw-cursor-pointer"
              onClick={() => setShowStatsModal(true)}
            >
              <p className="tw-text-[14px] tw-font-medium tw-underline">
                See more stats
              </p>
              <KeyboardArrowRightIcon style={{ fontSize: 22 }} />
            </div>
          </div>
        }
      />

      <ExlyModal
        open={showStatsModal}
        onClose={() => setShowStatsModal(false)}
        title="All stats and details"
        customFooter={
          <div className="tw-w-full tw-p-3">
            <button
              className="tw-w-full tw-flex tw-items-center tw-justify-center tw-gap-2 tw-border-none tw-bg-[#493AB1] tw-text-white tw-rounded-md tw-py-2 tw-font-medium"
              disabled={refreshLoading}
              onClick={() =>
                handleRefreshStats({
                  isWhatsApp: false,
                  campaignUuid: email?.email_key,
                })
              }
            >
              <p>Refresh stats</p>
              {refreshLoading ? (
                <CircularProgress size={18} color="inherit" />
              ) : (
                <RefreshIcon style={{ fontSize: 18 }} />
              )}
            </button>
          </div>
        }
      >
        <SeeMoreStatsModal
          record={email}
          columns={statsColumns(email)}
          isShowRefreshStat
          emailRetryText
          dripSource={DRIP_SOURCE.SALES_AND_MARKETING}
        />
      </ExlyModal>
    </>
  );
};

export default MobileRow;
